import {
  LanguageCode,
  LegacyOption,
  TextToSpeechVoice
} from '../../../types';

/** Gets the valid text to speech options for a given language. */
export function getTextToSpeechVoiceOptions(
  language: LanguageCode
): LegacyOption<TextToSpeechVoice>[] {
  let extraVoices: LegacyOption<TextToSpeechVoice>[] = [];
  switch (language) {
    case LanguageCode.arabicAe:
      extraVoices = getTextToSpeechVoiceOptions(LanguageCode.arabicXa);
      break;
    case LanguageCode.chineseCn:
      extraVoices = getTextToSpeechVoiceOptions(LanguageCode.chineseMandarinCn);
      break;
    case LanguageCode.englishGb:
      // Designs use en-GB, but TTS voices also use en-UK.
      extraVoices = getTextToSpeechVoiceOptions(LanguageCode.englishUk);
      break;
    case LanguageCode.spanishMx:
      // These voices are close enough since we do not have any es-MX voices.
      extraVoices = getTextToSpeechVoiceOptions(LanguageCode.spanishUs);
      break;
  }

  const search = `-${language}`;
  return extraVoices.concat(
    Object.values(TextToSpeechVoice).filter((voice) => {
      return voice.endsWith(search);
    }).map((voice): LegacyOption<TextToSpeechVoice> => {
      const nameEndIndex = voice.length - 1 - language.length;
      return {
        name: voice.slice(0, nameEndIndex).replace(/_/g, ' '),
        value: voice
      };
    }).sort((optionA, optionB) => {
      return optionA.name.localeCompare(optionB.name);
    })
  );
}
